/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SimpleUser } from './simple-user';
import { SimpleCompany } from './simple-company';

export interface BeneficialOwnerPEP {
  readonly id: string;
  readonly modified_date: string;
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  readonly status: string;
  readonly comment: string;
  readonly added_by: SimpleUser;
  readonly report_file_url: string;
  readonly company: SimpleCompany;
  readonly first_name: string;
  readonly last_name: string;
  readonly investment_company: SimpleCompany;
  readonly is_copy: boolean;
  readonly added_by_id: string | null;
}
